export const ROVER_SEARCH_SOURCE_TYPE_SEO_LOCATION = 5;
export const ROVER_SEARCH_SOURCE_TYPE_CACHEABLE = 8;
